import get from 'lodash/get';

export const trackSummaryProperties = (payload, properties) => {
  if (payload.summary) {
    properties.push({
      label: 'Summary Price Range Included',
      value: !!get(payload, 'summary.appraisalPriceRange.isEnabled'),
    }, {
      label: 'Summary Price Range Title',
      value: get(payload, 'summary.appraisalPriceRange.title'),
    }, {
      label: 'Summary Description Included',
      value: !!get(payload, 'summary.description.isEnabled'),
    }, {
      label: 'Summary Description Title',
      value: get(payload, 'summary.description.title'),
    });
  }
};